import { ActionSuggestion } from '../model'
import { useCurrentUserIntegrations } from '../../../views/Integration/useCurrentUserIntegrations'
import { useAppSelector } from '../../../store/hooks'
import { useFilterSuggestions } from './useFilterSuggestions'
import { selectRoomSession } from '../../../store/meetingSummary/roomSession'
import { selectTasks } from '../../../store/task/task'

export const useSaveTaskSuggestions = (): ActionSuggestion[] => {
  const roomSession = useAppSelector(selectRoomSession)
  const tasks = useAppSelector(selectTasks)
  const { taskExportSupportedIntegrations } = useCurrentUserIntegrations()

  const suggestions =
    roomSession && tasks
      ? taskExportSupportedIntegrations.map(
          (integration): ActionSuggestion => ({
            actionType: 'createTask',
            serviceId: integration.serviceId,
            roomSession: roomSession,
            tasks: tasks,
            externalIntegration: integration,
          }),
        )
      : []

  return useFilterSuggestions(suggestions, 'createTask')
}
